// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-basic-data {
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    gap: var(--space-and-half);
}

.edit-basic-data__title{
    /* margin-bottom: calc(var(--space-half) + 5px); */
    grid-column-start: 3;
    grid-column-end: 5;
}
.edit-basic-data__title__color{
    color: var(--primary-very-dark-color);
}

.edit-basic-data__form {
    grid-column-start: 3;
    grid-column-end: 9;
}

.edit-basic-data__form__content {
    margin-top: var(--space);
}

.edit-basic-data__form__content__input .input-field-multiline-input {
    background: var(--new-input-background-color);
    border-radius: 9px;
}

.edit-basic-data__form__content__input.name {
    margin-top: 0;
}

.edit-basic-data__form__form__input__gender {
    /* width: calc( var(--space-x2) *10 ); */
    width:60%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: var(--space-x2)
}

.edit-basic-data__form__form__input__gender.baloa-body-2 {
    color: var(--primary-dark-color) !important;
    flex-basis: 100%;
    text-transform: uppercase;
    margin-bottom: var(--space-half);
    font-weight: var(--font-bold);
    font-size: var(--space-half-quarter);
    letter-spacing: 0.004em;
    margin-left: 0px !important
}

.edit-basic-data__form__form__input-gender p{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-bold) !important;
    font-size: calc(var(--space-half-quarter) - 1px);
    line-height: var(--font-normal);
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--primary-very-dark-color);
}

.edit-basic-data__form__form__input-gender {
    border: 2px solid var(--mid-gray-color);
    border-radius: var(--space-and-half);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: var(--space-half) var(--space);
    height: var(--space-and-half);
    justify-content: center;
}

.edit-basic-data__form__form__input-gender.selected {
    border: 2px solid var(--secondary-light-color);
    border-radius: var(--space-and-half);
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: var(--space-half) var(--space);
    height: var(--space-and-half);
}

.grid-content{
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: var(--space-and-half);
}

.edit-basic-data__form__content__category {
    display: flex;
    justify-content: space-between;
}

.edit-basic-data__form__content__category__input{
    /* grid-column-start: 1;
    grid-column-end: 4; */
     
    margin-bottom: var(--space-x2); 
    width: 100%;
}

.edit-basic-data__form__content__category__input:first-of-type {
    margin-right: var( --space-and-half );
}

.edit-basic-data__form__content__category__input:last-of-type {
    margin-left: var( --space-and-half );
}

.edit-basic-data__form__content__category__input .baloa-body-2 {
    font-size: var(--space);
}
.edit-basic-data__form__content__category__input .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before{
    border: none;
}

.edit-basic-data__form__content__category__input .MuiInput-underline.select-field-input:before{
    border: none;
    transition: none;
}

.edit-basic-data__form__content__category__input .select-field .select-field-label{
    left: var( --space-and-half );
    padding: var(--space-half);
}

.edit-basic-data__form__content__category__input .MuiSelect-select.MuiSelect-select{
    padding: var(--space-half);
}

.edit-basic-data__form__content__city .MuiAutocomplete-root{
    grid-column-start: 1;
    grid-column-end: 4;
    margin-top: 0;
    /* margin-bottom: var(--space-x3); */
}

.edit-basic-data__form__content__citys{
    display: flex;
    justify-content: space-between;
}

.edit-basic-data__form__content__citys .input-field-auto-search:first-of-type {
    margin-right: var( --space-and-half );
}

.edit-basic-data__form__content__citys .input-field-auto-search:last-of-type {
    margin-left: var( --space-and-half );
}

.edit-basic-data__form__content__city__input,
.edit-basic-data__form__content__country__input {
    /* grid-column-start: 1;
    grid-column-end: 5;
    margin-top: 0; */
    width: 100%;
}

.edit-basic-data__form__content__date {
    display: flex;
    justify-content: space-between;
}

.edit-basic-data__form__content__date .input-field {
    width: 100%;
}

.edit-basic-data__form__content__date .input-field:first-of-type {
    margin-right:var( --space-and-half );
}

.edit-basic-data__form__content__date .input-field:last-of-type {
    margin-left:var( --space-and-half );
}

.edit-basic-data__form__actions div {
    display: flex;
    justify-content: flex-end;
    margin-bottom: var(--space-x2);
}

.edit-basic-data__form__content__country__input .MuiAutocomplete-popupIndicator { 
    display: none;
}

.edit-basic-data__form__content__city__input .MuiAutocomplete-popupIndicator { 
    display: none;
}

.edit-basic-data__form__content__category__input .select-field-icon{
    display: none;
}

/* .edit-basic-data__form__content__city__input{
    width: 45%;
    margin-left: var(--space-and-half);
} */

.edit-basic-data__form__content__category__input .select-field-input {
    border: none;
}

.tournament-edit-basic-data__cancel-btn {
    border: none;
    color: var(--basic-gray-color);
    margin-right: var( --space-and-half );
}

.tournament-edit-tournament-v2-form{
    padding: 5% 20%;
}

.tournament-edit-tournament-v2-buttons{
    display: flex;
    position: sticky;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 1;
    padding: var(--space);
    justify-content:flex-end;
    background : var(--white-color);
    border-top: 1px solid #ECECEC;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-edit-basic-data/TournamentEditBasicDataComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sCAAsC;IACtC,0BAA0B;AAC9B;;AAEA;IACI,kDAAkD;IAClD,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,qCAAqC;AACzC;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,6CAA6C;IAC7C,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wCAAwC;IACxC,SAAS;IACT,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf;AACJ;;AAEA;IACI,2CAA2C;IAC3C,gBAAgB;IAChB,yBAAyB;IACzB,gCAAgC;IAChC,6BAA6B;IAC7B,oCAAoC;IACpC,uBAAuB;IACvB;AACJ;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,wCAAwC;IACxC,gDAAgD;IAChD,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;IACI,uCAAuC;IACvC,oCAAoC;IACpC,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,8CAA8C;IAC9C,oCAAoC;IACpC,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uCAAuC;IACvC,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI;yBACqB;;IAErB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;IAEI;;oBAEgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;GAGG;;AAEH;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,qCAAqC;AACzC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,WAAW;IACX,UAAU;IACV,qBAAqB;IACrB,wBAAwB;IACxB,+BAA+B;IAC/B,6BAA6B;AACjC","sourcesContent":[".edit-basic-data {\n    display: grid;\n    grid-template-columns: repeat(10, 1fr);\n    gap: var(--space-and-half);\n}\n\n.edit-basic-data__title{\n    /* margin-bottom: calc(var(--space-half) + 5px); */\n    grid-column-start: 3;\n    grid-column-end: 5;\n}\n.edit-basic-data__title__color{\n    color: var(--primary-very-dark-color);\n}\n\n.edit-basic-data__form {\n    grid-column-start: 3;\n    grid-column-end: 9;\n}\n\n.edit-basic-data__form__content {\n    margin-top: var(--space);\n}\n\n.edit-basic-data__form__content__input .input-field-multiline-input {\n    background: var(--new-input-background-color);\n    border-radius: 9px;\n}\n\n.edit-basic-data__form__content__input.name {\n    margin-top: 0;\n}\n\n.edit-basic-data__form__form__input__gender {\n    /* width: calc( var(--space-x2) *10 ); */\n    width:60%;\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    margin-bottom: var(--space-x2)\n}\n\n.edit-basic-data__form__form__input__gender.baloa-body-2 {\n    color: var(--primary-dark-color) !important;\n    flex-basis: 100%;\n    text-transform: uppercase;\n    margin-bottom: var(--space-half);\n    font-weight: var(--font-bold);\n    font-size: var(--space-half-quarter);\n    letter-spacing: 0.004em;\n    margin-left: 0px !important\n}\n\n.edit-basic-data__form__form__input-gender p{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-bold) !important;\n    font-size: calc(var(--space-half-quarter) - 1px);\n    line-height: var(--font-normal);\n    display: flex;\n    align-items: center;\n    text-align: center;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: var(--primary-very-dark-color);\n}\n\n.edit-basic-data__form__form__input-gender {\n    border: 2px solid var(--mid-gray-color);\n    border-radius: var(--space-and-half);\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    padding: var(--space-half) var(--space);\n    height: var(--space-and-half);\n    justify-content: center;\n}\n\n.edit-basic-data__form__form__input-gender.selected {\n    border: 2px solid var(--secondary-light-color);\n    border-radius: var(--space-and-half);\n    box-sizing: border-box;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: var(--space-half) var(--space);\n    height: var(--space-and-half);\n}\n\n.grid-content{\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: var(--space-and-half);\n}\n\n.edit-basic-data__form__content__category {\n    display: flex;\n    justify-content: space-between;\n}\n\n.edit-basic-data__form__content__category__input{\n    /* grid-column-start: 1;\n    grid-column-end: 4; */\n     \n    margin-bottom: var(--space-x2); \n    width: 100%;\n}\n\n.edit-basic-data__form__content__category__input:first-of-type {\n    margin-right: var( --space-and-half );\n}\n\n.edit-basic-data__form__content__category__input:last-of-type {\n    margin-left: var( --space-and-half );\n}\n\n.edit-basic-data__form__content__category__input .baloa-body-2 {\n    font-size: var(--space);\n}\n.edit-basic-data__form__content__category__input .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before{\n    border: none;\n}\n\n.edit-basic-data__form__content__category__input .MuiInput-underline.select-field-input:before{\n    border: none;\n    transition: none;\n}\n\n.edit-basic-data__form__content__category__input .select-field .select-field-label{\n    left: var( --space-and-half );\n    padding: var(--space-half);\n}\n\n.edit-basic-data__form__content__category__input .MuiSelect-select.MuiSelect-select{\n    padding: var(--space-half);\n}\n\n.edit-basic-data__form__content__city .MuiAutocomplete-root{\n    grid-column-start: 1;\n    grid-column-end: 4;\n    margin-top: 0;\n    /* margin-bottom: var(--space-x3); */\n}\n\n.edit-basic-data__form__content__citys{\n    display: flex;\n    justify-content: space-between;\n}\n\n.edit-basic-data__form__content__citys .input-field-auto-search:first-of-type {\n    margin-right: var( --space-and-half );\n}\n\n.edit-basic-data__form__content__citys .input-field-auto-search:last-of-type {\n    margin-left: var( --space-and-half );\n}\n\n.edit-basic-data__form__content__city__input,\n.edit-basic-data__form__content__country__input {\n    /* grid-column-start: 1;\n    grid-column-end: 5;\n    margin-top: 0; */\n    width: 100%;\n}\n\n.edit-basic-data__form__content__date {\n    display: flex;\n    justify-content: space-between;\n}\n\n.edit-basic-data__form__content__date .input-field {\n    width: 100%;\n}\n\n.edit-basic-data__form__content__date .input-field:first-of-type {\n    margin-right:var( --space-and-half );\n}\n\n.edit-basic-data__form__content__date .input-field:last-of-type {\n    margin-left:var( --space-and-half );\n}\n\n.edit-basic-data__form__actions div {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: var(--space-x2);\n}\n\n.edit-basic-data__form__content__country__input .MuiAutocomplete-popupIndicator { \n    display: none;\n}\n\n.edit-basic-data__form__content__city__input .MuiAutocomplete-popupIndicator { \n    display: none;\n}\n\n.edit-basic-data__form__content__category__input .select-field-icon{\n    display: none;\n}\n\n/* .edit-basic-data__form__content__city__input{\n    width: 45%;\n    margin-left: var(--space-and-half);\n} */\n\n.edit-basic-data__form__content__category__input .select-field-input {\n    border: none;\n}\n\n.tournament-edit-basic-data__cancel-btn {\n    border: none;\n    color: var(--basic-gray-color);\n    margin-right: var( --space-and-half );\n}\n\n.tournament-edit-tournament-v2-form{\n    padding: 5% 20%;\n}\n\n.tournament-edit-tournament-v2-buttons{\n    display: flex;\n    position: sticky;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    z-index: 1;\n    padding: var(--space);\n    justify-content:flex-end;\n    background : var(--white-color);\n    border-top: 1px solid #ECECEC;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
